import _regeneratorRuntime from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.to-string.js";
import { isEngineer, currentUser, permissionList, destroyToken, setClientData, getClientData } from "@/core/services/jwt.service";
import { isEmpty, isObject, assign, includes, cloneDeep, findIndex, toString, isError } from "lodash";
import inflect from "i";
import axios from "axios";

var GenicSetting = /*#__PURE__*/function () {
  function GenicSetting() {
    _classCallCheck(this, GenicSetting);

    this.$isEngineerChannel = false;
  }
  /*permissionDenied(el, vnode) {
    // replace HTMLElement with comment node
    const comment = document.createComment(" Permission Denied ");
    Object.defineProperty(comment, "setAttribute", {
      value: () => undefined
    });
    vnode.elm = comment;
    vnode.text = " ";
    vnode.isComment = true;
    vnode.context = undefined;
    vnode.tag = undefined;
    vnode.data.directives = undefined;
     if (vnode.componentInstance) {
      vnode.componentInstance.$el = comment;
    }
     if (el.parentNode) {
      el.parentNode.replaceChild(comment, el);
    }
  }*/


  _createClass(GenicSetting, [{
    key: "install",
    value: function install(Vue) {
      var _this = this;

      Vue.mixin({
        methods: {
          limitDecimal: function limitDecimal($event, value) {
            var string = toString(value); // console.log($event.keyCode); //keyCodes string

            var keyCode = $event.keyCode ? $event.keyCode : $event.which; // only allow number and one dot

            if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || string.indexOf(".") != -1)) {
              // 46 is dot
              $event.preventDefault();
            } // restrict to 2 decimal places


            if (string != null && string.indexOf(".") > -1 && string.split(".")[1].length > 1) {
              $event.preventDefault();
            }
          },
          getDefaultRoute: function getDefaultRoute(route, params) {
            var route_name = "admin." + route;

            if (_this.$isEngineerChannel) {
              route_name = "engineer." + route;
            }

            var result = {
              name: route_name
            };

            if (isEmpty(params) === false && isObject(params)) {
              assign(result, params);
            }

            return result;
          },
          setChannelType: function setChannelType() {
            isEngineer().then(function (response) {
              _this.$isEngineerChannel = response;
            }).catch(function (error) {
              _this.logError(error);
            });
          },
          setPageTitle: function setPageTitle() {
            var route = this.$route;

            if (isEmpty(route) === false) {
              if (isEmpty(route.meta) === false && isObject(route.meta)) {
                document.title = inflect().titleize(route.meta.title) + " | Genic Teams";
              }
            }
          },
          goBack: function goBack() {
            this.$router.go(-1);
          },
          getCurrentUser: function getCurrentUser() {
            return currentUser();
          },
          getPermissions: function getPermissions() {
            return permissionList();
          },
          getPermission: function getPermission(key) {
            try {
              var permissions = permissionList();

              if (isEmpty(permissions) === false) {
                var keyArray = key.split(":");
                keyArray[1] = "full-access";
                var fullAccessKey = keyArray.join(":");

                if (includes(permissions, fullAccessKey)) {
                  return true;
                }

                return includes(permissions, key);
              } else {
                destroyToken();
              }
            } catch (error) {
              _this.logError({
                error: error
              });

              destroyToken();
            }
          },
          isEngineerChannel: function isEngineerChannel() {
            return _this.$isEngineerChannel;
          },
          checkTransactionPermission: function checkTransactionPermission() {
            var _this = this;

            var transactions = cloneDeep(_this.createTransactions);

            for (var i = 0; i < transactions.length; i++) {
              if (!_this.getPermission(toString(transactions[i].action) + ":create")) {
                var index = findIndex(_this.createTransactions, {
                  action: transactions[i].action
                });

                if (index >= 0) {
                  _this.createTransactions.splice(index, 1);
                }
              }
            }
          },
          checkTabPermission: function checkTabPermission() {
            var _this = this;

            var tabs = cloneDeep(_this.tabs);

            for (var i = 0; i < tabs.length; i++) {
              if (!_this.getPermission(toString(tabs[i].key) + ":view")) {
                var index = findIndex(_this.tabs, {
                  key: tabs[i].key
                });

                if (index >= 0) {
                  _this.tabs.splice(index, 1);
                }
              }
            }
          },
          getClientDetail: function getClientDetail() {
            return new Promise(function (resolve, reject) {
              var clientData = getClientData();

              if (isEmpty(clientData) === false) {
                resolve(clientData);
              } else {
                axios.get("https://ipgeolocation.abstractapi.com/v1", {
                  params: {
                    api_key: process.env.VUE_APP_ABSTRACTAPI_KEY
                  }
                }).then(function (_ref) {
                  var data = _ref.data;
                  setClientData(data);
                  resolve(data);
                }).catch(function (error) {
                  reject(error);
                });
              }
            });
          },
          logError: function logError(error) {
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      try {
                        console.warn(error);
                        /*let clientDetails = await this.getClientDetail();
                        axios
                          .post(
                            process.env.VUE_APP_SLACK_WEBHOOK_URL,
                            JSON.stringify(this.createPayload(clientDetails, error)),
                            {
                              withCredentials: false,
                              transformRequest: [
                                (data, headers) => {
                                  delete headers.post["Content-Type"];
                                  delete headers.common["Authorization"];
                                  return data;
                                }
                              ]
                            }
                          )
                          .catch(error => {
                            console.warn(error);
                          });*/
                      } catch (error) {
                        console.warn(error);
                      }

                    case 1:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }))();
          },
          createPayload: function createPayload(clientDetails, clientError) {
            try {
              var route = this.$route.fullPath;
              var client = JSON.stringify(clientDetails, null, 4);
              var user = JSON.stringify(this.getCurrentUser(), null, 4);
              var error = typeof clientError == "string" ? clientError : JSON.stringify(clientError, null, 4);

              if (isError(clientError)) {
                error = JSON.stringify(clientError.stack, null, 4);
              }

              var errorText = "Something went wrong";

              if (typeof clientError == "string") {
                errorText = clientError.toString();
              }

              return new Object({
                attachments: [{
                  fallback: "You have a new Error",
                  color: "#F64E60",
                  title: process.env.VUE_APP_CLIENT_NAME,
                  title_link: process.env.VUE_APP_CLIENT_DOMAIN,
                  text: errorText,
                  fields: [{
                    title: "Priority",
                    value: "High",
                    short: false
                  }, {
                    title: "Client",
                    value: "```" + client + "```",
                    short: false
                  }, {
                    title: "User",
                    value: "```" + user + "```",
                    short: false
                  }, {
                    title: "Exception",
                    value: "```" + error + "```",
                    short: false
                  }, {
                    title: "Route",
                    value: "```" + process.env.VUE_APP_BASE_URL + route.substring(1) + "```",
                    short: false
                  }],
                  footer: "Genic Teams",
                  footer_icon: process.env.VUE_APP_BASE_URL + "android-chrome-512x512.png",
                  ts: new Date().getTime()
                }]
              });
            } catch (error) {
              return new Object({
                attachments: [{
                  fallback: "You have a new Error",
                  color: "#F64E60",
                  title: process.env.VUE_APP_CLIENT_NAME,
                  title_link: process.env.VUE_APP_CLIENT_DOMAIN,
                  text: "*Error*: \n" + error.toString(),
                  fields: [{
                    title: "Priority",
                    value: "High",
                    short: false
                  }, {
                    title: "Exception",
                    value: "```" + JSON.stringify(error.stack, null, 4) + "```",
                    short: false
                  }, {
                    title: "Route",
                    value: "```" + process.env.VUE_APP_BASE_URL + this.$route.fullPath.substring(1) + "```",
                    short: false
                  }],
                  footer: "Genic Teams",
                  footer_icon: process.env.VUE_APP_BASE_URL + "android-chrome-512x512.png",
                  ts: new Date().getTime()
                }]
              });
            }
          }
        },
        created: function created() {
          this.setChannelType();
          this.setPageTitle();
        },
        errorCaptured: function errorCaptured(err, vm, info) {
          this.logError({
            err: err,
            vm: vm,
            info: info
          });
        }
      });
    }
  }]);

  return GenicSetting;
}();

export default new GenicSetting();